/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export enum ERROR_COLORS {
  notification = "notification",
  danger = "danger",
}

export enum TAG_COLORS {
  danger = "danger",
  primary = "primary",
}
